import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';

const CHUNK_RELOAD_KEY = 'chunk-load-error-reloaded';

function isChunkLoadError(error: any): boolean {
  return error?.name === 'ChunkLoadError' || /Loading chunk [\w-]+ failed/i.test(error?.message ?? '');
}

export function Error() {
  const error: any = useRouteError();
  const chunkLoadError = isChunkLoadError(error);
  const alreadyReloaded = typeof window !== 'undefined' && sessionStorage.getItem(CHUNK_RELOAD_KEY);

  useEffect(() => {
    if (chunkLoadError && !alreadyReloaded) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
      window.location.reload();
    }
  }, [chunkLoadError]);

  if (chunkLoadError && !alreadyReloaded) {
    return null;
  }

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{error?.statusText || error?.message}</i>
      </p>
    </div>
  );
}
